<app-modal-card [visible]="visible" [closable]="false">
	<h1 class="mb-6 text-center">{{ title }}</h1>
	<div class="flex flex-col items-center">
		<app-loader></app-loader>
		<p class="mt-2 mb-6 text-sm font-medium text-almost-black">{{ text }}</p>
	</div>
</app-modal-card>
